var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPortuguese(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 19.29 12.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clippath);}.cls-3{fill:#032a74;}.cls-4{fill:#fcdc32;}.cls-5{fill:#fff;}.cls-6{fill:#15993f;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0,
    width: 19.29,
    height: 12.86
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Text_Generator"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m0,0h19.29v12.86H0V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m9.645.726l7.705,5.693-7.705,5.689L1.903,6.419,9.645.726Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m9.645,9.453c1.67,0,3.023-1.354,3.023-3.023s-1.354-3.023-3.023-3.023-3.023,1.354-3.023,3.023,1.354,3.023,3.023,3.023Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m8.118,6.231c-.523,0-1.03.079-1.508.226.023,1.651,1.365,2.982,3.019,2.982,1.023,0,1.929-.511,2.474-1.29-.936-1.166-2.376-1.918-3.986-1.918Zm4.475.763c.034-.188.056-.38.056-.579,0-1.67-1.354-3.023-3.023-3.023-1.245,0-2.313.756-2.779,1.827.41-.083.831-.128,1.263-.128,1.76.004,3.347.733,4.482,1.903Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortuguese);
export default __webpack_public_path__ + "static/media/portuguese.0a809e42aabf49e56af7f5cd79153470.svg";
export { ForwardRef as ReactComponent };